import React from 'react'
import { formContent } from "./content"
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Button from "../../../../Components/Form/Button/Button";
import { useForm, FormProvider } from "react-hook-form";
import Dropdown from "../../../../Components/Form/Dropdown/Dropdown";
import MultiImageUpload from "../../../../Components/Form/MultiImageUpload/MultiImageUpload";
import EventApi from "../../../../Api/EventApi";
import {getResponseError, getUserDetailsCookie} from "../../../../Api/Utils/apiUtils";
import {formatDate, formatTime} from "../../../../Api/Utils/dateUtils";
import AutocompleteAddress from "../../../../Components/Form/AutocompleteAddress/AutocompleteAddress";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import SuccessAlert from "../../../../Components/Form/SuccessAlert/SuccessAlert";

const AddEventForm = () => {
    const {
        heading,
        personName,
        eventName,
        eventDescription,
        eventType,
        eventBudget,
        eventDate,
        eventStartTime,
        noEndTime,
        eventEndTime,
        rsvpDate,
        eventAddress,
        state,
        latitude,
        longitude,
        eventImages,
        addEventButton
    } = formContent;

    const [errorMessage, setErrorMessage] = React.useState(null);
    const [successMessage, setSuccessMessage] = React.useState(null);
    const [eventTypes, setEventTypes] = React.useState([]);
    const [eventTypeImages, setEventTypeImages] = React.useState([]);
    const [eventUploadImages, setEventUploadImages] = React.useState([]);
    const [eventEndTimeProps, setEventEndTimeProps] = React.useState(eventEndTime);

    React.useEffect(() => {
        const loadEventTypes = async () => {
            const response = await EventApi.getEventTypes();
            const eventTypeList =response.objectVal;
            eventTypeList.forEach(e => {
                e.value = e.id;
                e.label = e.title;
            });
            setEventTypes(eventTypeList);
            setEventTypeImages(eventTypeList[0].GeteventTypeImage);
        };
        loadEventTypes();
    }, []);

    const formBinding = useForm();
    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));

    const updateEventTypeImages = (event) => {
        const eventTypeId = parseInt(event.target.value);
        const eventType = eventTypes.find(e => e.id === eventTypeId);
        setEventTypeImages(eventType.GeteventTypeImage);
        setEventUploadImages([]);
    }
    const hideEventEndTime = (event) => {
        const ticked = event.target.checked;
        if (ticked) {
            setEventEndTimeProps(props => ({...props, 'type': 'hidden'}));
        } else {
            setEventEndTimeProps(eventEndTime);
        }
    }
    const submitForm = async (data) => {
        const uploadImageFiles = [];
        eventUploadImages.forEach(o => uploadImageFiles.push(o.file));
        data.imageUrl = uploadImageFiles;
        const eventTypeImageIds = []
        eventTypeImages.forEach(o => eventTypeImageIds.push(o.id));
        data.eventTypeImages = eventTypeImageIds.join(",");
        const userDetails = getUserDetailsCookie();
        data.userId= userDetails.id;
        data.eventDate = formatDate(data.eventDate);
        data.rsvpDate = formatDate(data.rsvpDate);
        data.eventTime = formatTime(data.eventTime);
        data.eventEndTime = !data.noEndTime? formatTime(data.eventEndTime): '';
        
        const response = await EventApi.addEvent(data);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            setSuccessMessage("Event added successfully")
        }
    }
    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <SuccessAlert>{successMessage}</SuccessAlert>
                <FormProvider {...formBinding}>
                    <form id="login-form" onSubmit={handleSubmit(submitForm)}>
                        <TextInput {...personName} />
                        <TextInput {...eventName} />
                        <TextInput {...eventDescription} />
                        <Dropdown {...eventType} options={eventTypes} action={updateEventTypeImages}/>
                        <TextInput {...eventBudget} />
                        <TextInput {...eventDate} />
                        <TextInput {...eventStartTime} />
                        <TextInput {...noEndTime} onClick={hideEventEndTime}/>
                        <TextInput {...eventEndTimeProps} />
                        <TextInput {...rsvpDate} />
                        <AutocompleteAddress {...eventAddress} />
                        <TextInput {...state} />
                        <TextInput {...latitude} />
                        <TextInput {...longitude} />
                        <MultiImageUpload {...eventImages}
                            defaultImages={eventTypeImages}
                            setDefaultImages={setEventTypeImages}
                            uploadImages={eventUploadImages}
                            setUploadImages={setEventUploadImages} />
                        <Button {...addEventButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default AddEventForm
